module.exports = __webpack_public_path__ + "static/media/SimpleLineIcons.f3ea8969.ttf";